unit UConstantes;

interface

const
// Define o valor do timer para telas de consulta
  FTimerConsulta = 800;

  FRecursosDisponiveis : array[0..5] of String = ('Whatsapp', 'Sincronização automática de boletos',
    'Fácil NFSe', 'Painel Ofertas', 'PIX Integrado', 'Recuperação automática DB');

  FServidoresDisponiveis : array[0..3] of String = ('Service', 'Mensagens', 'WhatsApp', 'Painel Aliados');

  FIdsTabelasPermitemExclusao : array[0..2] of String = ('108', '86', '34');

  cRotasHeaderResolucao : array[0..4] of String = ('/promocoes_itens', '/produtos', '/fs_prod_produtos',
    '/getprodutoselasticsearchfrontend', '/getsugestaoassociacaoprodutos');
implementation

end.
